import config from "./clientConfig";
export var createUniversalNavScript = function createUniversalNavScript() {
  var script = document.createElement('script');
  script.dataset.id = 'universal-navigation-script';
  script.src = config.UNIVERSAL_URL;
  script.async = true;
  document.body.appendChild(script);
};
export default createUniversalNavScript;